import axios from 'axios';
import urlParse from 'url-parse';
import { Url } from '../url';
import { AttributionData } from '@scorewarrior/rubens_web_lib/lib/hub-api/protocol/attribution-data';

export type FbUserData = {
    fbId?: string | null;
    fbp?: string | null;
    firstName?: string | null;
    lastName?: string | null;
};

export type MarketingData = {
    ref?: string | null;
    partner?: string | null;
    campaign?: string | null;
    clickId?: string | null;
    referrer?: string | null;
    isSuitableForSave?: boolean | null;
    authOption?: string | null;
    fbData?: FbUserData | null;
    attributionData?: AttributionData | null
};

export type RetentionData = {
    fdretention: number;
    ret1: boolean;
    ret7: boolean;
};

export async function getMarketingData(): Promise<MarketingData> {
    try {
        const currentUrl = urlParse(window.location.href, true);
        const response = await axios.get(
            Url.getNoLangUrl('marketing/getData/'),
            { params: currentUrl.query }
        );

        return response.data;
    } catch (error) {
        console.error('Error fetching marketing data: ', error);
        return {};
    }
}

export async function getRetentionData(
    isSuidSimulate: number,
    registerTs: number,
    registration: number
): Promise<RetentionData> {
    try {
        const response = await axios.get(
            Url.getNoLangUrl('marketing/getRetentionData/'),
            {
                params: {
                    isSuidSimulate: isSuidSimulate,
                    registerTs: registerTs,
                    registration: registration
                }
            }
        );

        return response.data;
    } catch (error) {
        console.error('Error fetching retention data: ', error);
        return {
            fdretention: 0,
            ret1: false,
            ret7: false
        };
    }
}
